import React from "react";

type ErrorLayoutProps = {
  /**
   * When true, fills the parent's content area instead of the viewport, so the
   * surrounding CommonLayout navigation stays visible and usable.
   */
  contained?: boolean;
};

export const ErrorLayout = ({ contained = false }: ErrorLayoutProps) => {
  return (
    <div
      data-testid="app-error"
      className={`text-gray-300 text-center flex flex-col items-center justify-center ${
        contained ? "w-full min-h-[60vh]" : "w-[100vw] h-[100vh]"
      }`}
    >
      <h1>Oops! Something went wrong.</h1>
      <p className="mb-5">
        We're working on fixing this. Please try again later.
      </p>
      {/* Show/Hide Details button to toggle error details */}
    </div>
  );
};
